var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"avatar avatar_lg"},[_c('div',{staticClass:"icon-girl-child flex-center font-48"},_vm._l((_vm.paths),function(num,index){return _c('div',{key:index,class:'path'+num})}),0)])])}
var staticRenderFns = []

export { render, staticRenderFns }